import _ from "lodash";
import LayoutConfig from "./LayoutConfig";
import {
  moneyToNumValue
} from "./tools";

export default class CascaderManager {
  static triggerCascader(cascaders, config, vm) {
    if (_.isArray(cascaders) && cascaders.length > 0) {
      cascaders.forEach(cascader => {
        if (_.isObject(cascader)) {
          // isFinish 是否满足条件队列 requirements
          let isComplete = true;
          for (let index = 0; index < cascader.requirements.length; index++) {
            if (
              isComplete &&
              _.isFunction(CascaderManager[cascader.requirements[index].name]) && !cascader.requirements[index].isCheckDependParams
            ) {
              isComplete = CascaderManager[cascader.requirements[index].name](
                config,
                config.value,
                cascader.requirements[index].params
              );
            } else if (cascader.requirements[index].isCheckDependParams) {
              isComplete = CascaderManager[cascader.requirements[index].name](
                config,
                vm.params[cascader.requirements[index].dependParams],
                cascader.requirements[index].params
              );
            }
            if (isComplete === false) {
              break;
            }
          }
          // 执行动作
          if (isComplete) {
            if (cascader.targetFieldPath) { // 应用场景举例项目付款申请发票的联动配置
              CascaderManager.setTargetFormVm(vm, cascader.targetFieldPath);
              if (vm.targetVm) {
                cascader.actions.forEach(action => {
                  if (_.isFunction(CascaderManager[action.name])) {
                    CascaderManager[action.name](
                      vm.targetVm, // CommonForm组件（用来查找target）
                      cascader.target, // 联动目标field
                      action.params, //  联动执行的函数的参数（根据需求自定义参数）
                      config, // 是谁触发的联动
                      cascader.depends // 联动依赖参数（可参照餐补加班日期联动金额）
                    );
                  }
                });
              }
            } else {
              cascader.actions.forEach(action => {
                if (_.isFunction(CascaderManager[action.name])) {
                  CascaderManager[action.name](
                    vm, // CommonForm组件（用来查找target）
                    cascader.target, // 联动目标field
                    action.params, //  联动执行的函数的参数（根据需求自定义参数）
                    config, // 是谁触发的联动
                    cascader.depends // 联动依赖参数（可参照餐补加班日期联动金额）
                  );
                }
              });
            }
          }
        }
      });
    }
  }

  // 获取联动目标(非同一个CommonForm)所在的组件vm
  static setTargetFormVm(vm, targetFieldPath) {
    vm.$EventBus.$emit('setTargetFormVm', {
      targetFieldPath: targetFieldPath,
      triggerVm: vm
    });
  }

  static initData(vm, targetId, params = {}, ) {
    const target = LayoutConfig.getConfigByField(vm.formConfig.contents, targetId);
    target.value = undefined;
    LayoutConfig.dispfetchByConfig(
        vm,
        vm.formConfig.contents,
        target,
      )
      .then(res => {
        if (res.status === 'success') {
          target.options = res.data;
        } else {
          vm.$Message.error(res.message);
        }
      })
  }


  static show(vm, targetId) {
    const target = LayoutConfig.getConfigByField(vm.formConfig.contents, targetId);

    if (target) target.show = true;
    if (target && target.trigger && target.show) {
      CascaderManager.triggerCascader(target.trigger, target, vm);
    }
  }

  static hidden(vm, targetId) {
    const target = LayoutConfig.getConfigByField(vm.formConfig.contents, targetId);
    if (target) {
      if (target.selectObj) {
        target.selectObj = undefined;
      };
      target.show = false;
    }
  }

  static required(vm, targetId) {
    const target = LayoutConfig.getConfigByField(vm.formConfig.contents, targetId);
    if (target) target.required = true;
  }

  static cancelRequired(vm, targetId) {
    const target = LayoutConfig.getConfigByField(vm.formConfig.contents, targetId);
    if (target) target.required = false;

  }

  static clear(vm, targetId, params = {}) {
    vm.clearByField(targetId);
  }

  static changeLabel(vm, targetId, params = {}) {
    const target = LayoutConfig.getConfigByField(vm.formConfig.contents, targetId);
    if (target) target.label = params.newLabel;
  }


  static updateLayout() {
    arguments[0].instance.updateLayout(arguments[3]);
  }

  static valueBind(vm, targetId, params = {}, config) {
    let target = LayoutConfig.getConfigByField(vm.formConfig.contents, targetId);
    if (config.selectObj) {
      vm.formParamsInit[targetId] = config.selectObj[targetId];
      target.value = vm.formParamsInit[targetId];
    }
  }

  // 例:报销工作餐费加班日期触发的联动计算付款金额、采购申请单价*数量自动计算金额
  static multiply(vm, targetId, params = {}, config, depends = []) {
    let target = LayoutConfig.getConfigByField(vm.formConfig.contents, targetId);
    const dependsFieldName = Object.keys(depends[0])[0];
    const dependsConfig = LayoutConfig.getConfigByField(vm.formConfig.contents, dependsFieldName);
    const dependsConfigvalue = typeof dependsConfig.value === 'string' ? moneyToNumValue(dependsConfig.value) : dependsConfig.value;

    if (dependsConfig && target.type === 'text' && dependsConfig.value) {
      if (_.isArray(config.value)) { //例如加班日期是数组要通过天数计算
        vm.formParamsInit[targetId] = Number(dependsConfigvalue) * (config.value ? config.value.length : 0);
        target.value = vm.formParamsInit[targetId];
      } else {
        const configValue = typeof config.value === 'string' ? moneyToNumValue(config.value) : config.value;
        vm.formParamsInit[targetId] = Number(dependsConfigvalue) * Number(configValue);
        target.value = vm.formParamsInit[targetId];
      }
    } else if (dependsConfig && dependsConfig.value) {
      let formParams = vm.form.getFieldsValue();
      const configValue = typeof config.value === 'string' ? moneyToNumValue(config.value) : config.value;
      const count = _.isArray(config.value) ? config.value.length : configValue;
      const val = Number(dependsConfigvalue) * count
      if (vm.optionInit) {
        formParams[targetId] = target.type === 'number' ? val : val.toFixed(2);
        vm.form.setFieldsValue(formParams);
        vm.setEmitParams();
      } else {
        vm.params[targetId] = target.type === 'number' ? val : val.toFixed(2);
      }
    }
  }

  static divide(vm, targetId, params = {}, config, depends = []) {
    let target = LayoutConfig.getConfigByField(vm.formConfig.contents, targetId);
    const dependsFieldName = Object.keys(depends[0])[0];
    const dependsConfig = LayoutConfig.getConfigByField(vm.formConfig.contents, dependsFieldName);
    const dependsConfigvalue = typeof dependsConfig.value === 'string' ? moneyToNumValue(dependsConfig.value) : dependsConfig.value;

    if (dependsConfig && target.type === 'text' && dependsConfig.value) {
      const configValue = typeof config.value === 'string' ? moneyToNumValue(config.value) : config.value;
      vm.formParamsInit[targetId] = Number(configValue) / Number(dependsConfigvalue);
      target.value = vm.formParamsInit[targetId];
    } else if (dependsConfig && dependsConfig.value) {
      let formParams = vm.form.getFieldsValue();
      const configValue = typeof config.value === 'string' ? moneyToNumValue(config.value) : config.value;
      const val = Number(configValue) / Number(dependsConfigvalue);
      if (vm.optionInit) {
        formParams[targetId] = target.type === 'number' ? val : val.toFixed(2);
        vm.form.setFieldsValue(formParams);
        vm.setEmitParams();
      } else {
        vm.params[targetId] = target.type === 'number' ? val : val.toFixed(2);
      }
    }
  }

  static setCount(vm, targetId, params = {}, config, depends = []) {
    let target = LayoutConfig.getConfigByField(vm.formConfig.contents, targetId);
    if (_.isArray(config.value)) {
      vm.formParamsInit[targetId] = config.value ? config.value.length : 0;
      target.value = vm.formParamsInit[targetId];
    }
  }

  static disabled(vm, targetId) {
    const target = LayoutConfig.getConfigByField(vm.formConfig.contents, targetId);

    if (target) target.disabled = true;
  }

  static notDisabled(vm, targetId) {
    const target = LayoutConfig.getConfigByField(vm.formConfig.contents, targetId);

    if (target) target.disabled = false;
  }

  //应用场景举例：报销单实际申请人联动更改公司信息、付款单里付款类别联动发票
  static updateValueByDriver(vm, targetId, params = {}, config) {
    let target = LayoutConfig.getConfigByField(vm.formConfig.contents, targetId);
    if (config.selectObj && config.selectObj[targetId] && vm.optionInit) {
      // vm.params[targetId] = config.selectObj[targetId];
      let formParams = vm.form.getFieldsValue();
      formParams[targetId] = config.selectObj[targetId];
      target.value = formParams[targetId]
      vm.form.setFieldsValue(formParams);
      vm.setEmitParams();
      if (target && target.trigger && target.show) {
        CascaderManager.triggerCascader(target.trigger, target, vm);
      }
    }
  }

  // static setParams(targetId, params = {}) {
  //   const target = LayoutConfig.getConfigByField(configs, targetId);
  //   CascaderManager.promiseDelay(params.delay).then(() => {
  //     if (target && target.instance)
  //       target.instance.params[target.key] = params.value;
  //   });
  // }

  // static setData(targetId, params = {}) {
  //   const target = LayoutConfig.getConfigByField(configs, targetId);
  //   CascaderManager.promiseDelay(params.delay).then(() => {
  //     if (target) _.assign(target, params);
  //   });
  // }

  static equal(config, value, params) {
    if (value && value == params.value) {
      return true;
    }
    return false;
  }

  static notEqual(config, value, params) {
    if (value && value !== params.value) {
      return true;
    }
    return false;
  }

  static gt(config, value, params) {
    if (value && String(value) > String(params.value)) {
      return true;
    }
    return false;
  }

  static lt(config, value, params) {
    if (value && String(value) < String(params.value)) {
      return true;
    }
    return false;
  }

  static gtOrEqual(config, value, params) {
    if (value && String(value) >= String(params.value)) {
      return true;
    }
    return false;
  }

  static ltOrEqual(config, value, params) {
    if (value && String(value) <= String(params.value)) {
      return true;
    }
    return false;
  }

  static include(config, value, params) {
    if (value && params.value.indexOf(value) !== -1) {
      return true;
    }
    return false;
  }

  static notInclude(config, value, params) {
    if (value && params.value.indexOf(value) === -1) {
      return true;
    }
    return false;
  }

  static exist(config, value, params) {
    if (value !== undefined && value !== null && value !== '') {
      return true;
    }
    return false;
  }

  static notExist(config, value, params) {
    if (value === undefined || value === null || value === '') {
      return true;
    }
    return false;
  }

  static isTriggerDisabled(config, value, params) {
    if (config.selectObj && config.selectObj.isTriggerDisabled) {
      return true;
    }
    return false;
  }

  static dependParamsCheck(config, value, params) {
    if (value && value == params.value) {
      return true;
    }
    return false;
  }

  static promiseDelay(delay = 0) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, delay);
    });
  }

}

CascaderManager.cascaders = {};